import React, { useCallback } from "react";
import { Pressable, StyleSheet } from "react-native";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { Icon, type IconName } from "../Icon";
import type { ViewProps, ViewStyle } from "react-native";

const S = StyleSheet.create({
  iconContainer: {
    width: 38,
    height: 38,
    borderRadius: 19,
    justifyContent: "center",
    alignItems: "center",
  },
});

type Size = "small" | "medium" | "large" | "extra-large" | undefined;

export const ButtonCircle = ({
  iconName,
  onPress,
  size = "medium",
  pointerEvents,
  backgroundColor,
}: {
  iconName: IconName;
  onPress?: () => void;
  size: Size;
  pointerEvents?: ViewProps["pointerEvents"];
  backgroundColor?: ViewStyle["backgroundColor"];
}) => {
  const resolveIconSize = useCallback(() => {
    switch (size) {
      case "small":
        return 24;
      case "medium":
        return 30;
      case "large":
        return 40;
      case "extra-large":
        return 50;
      default:
        return 30;
    }
  }, [size]);

  const resolveContainerSize = useCallback(() => {
    switch (size) {
      case "small":
        return 32;
      case "medium":
        return 40;
      case "large":
        return 50;
      case "extra-large":
        return 50;
      default:
        return 40;
    }
  }, [size]);

  return (
    <Pressable
      style={[
        S.iconContainer,
        {
          width: resolveContainerSize(),
          height: resolveContainerSize(),
          backgroundColor: backgroundColor || styleConstantsV2.colorWhite,
          pointerEvents,
        },
      ]}
      onPress={onPress}
    >
      <Icon
        name={iconName}
        size={resolveIconSize()}
        color={styleConstantsV2.colorBlack}
      />
    </Pressable>
  );
};
